export default {
    list: (state) => (optionId) => {
        return state.list.find(image => image.optionId == optionId).data;
    }
}
